import styled from 'styled-components'
import { sv } from '@ucheba/utils/helpers/styles/variables'

const Block = styled.div<{ isDivider: boolean }>`
  padding-top: ${sv.spacing.xlarge};
  padding-bottom: ${sv.spacing.xlarge};

  border-top: 1px solid ${({ isDivider }) => (isDivider ? sv.color.gray9 : 'none')};
`
export default { Block }
